import { stat } from "fs";

const state = {
	nameOfGraph: ""
};

const mutations = {
	setNameOfGraph: (state, payload) => {
		state.nameOfGraph = payload;
	}
};

const getters = {
	getNameOfGraph: state => state.nameOfGraph
};

export default {
	state,
	mutations,
	getters
};
